import { useMutation } from "@apollo/client/react";
import { SEND_MULTIPLE_FOR_INTERPRETATION_WITH_TEMPLATE } from "../../mutations/documentHandler/sendMultipleForInterpretationWithTemplate";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";

export const useSendMultipleForInterpretationWithTemplate = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: () => void;
}) => {
  const [interpretMultipleWithTemplate, { data, loading, error }] = useMutation(
    SEND_MULTIPLE_FOR_INTERPRETATION_WITH_TEMPLATE,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_CLIENTS_WITH_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    },
  );

  return { interpretMultipleWithTemplate, data, loading, error };
};
